import { createNewProducts } from "api/Customers";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useCreateNewProduct = () => {
  const queryClient = useQueryClient();

  return useMutation(createNewProducts, {
    onSuccess: () => {
      toast.success("Created Successfully");
      queryClient.invalidateQueries(["customerProducts", "coustomers"]);
      queryClient.invalidateQueries(['widgetData', 'Customers Latest List'])
      queryClient.invalidateQueries(['widgetData', 'Upcoming Appointments'])
      queryClient.invalidateQueries(["coustomers"]);
    },
    onError: (error: any) => {
      toast.error(error.response.data.error || 'Something went wrong! Please try again later.');
    },
  });
};
